export const LOAD_CONTEST_REQUEST = 'CMSEditContest/LOAD_CONTEST_REQUEST';
export const LOAD_CONTEST_SUCCESS = 'CMSEditContest/LOAD_CONTEST_SUCCESS';
export const LOAD_CONTEST_FAILURE = 'CMSEditContest/LOAD_CONTEST_FAILURE';
export const UPDATE_CONTEST_REQUEST = 'CMSEditContest/UPDATE_CONTEST_REQUEST';
export const UPDATE_CONTEST_SUCCESS = 'CMSEditContest/UPDATE_CONTEST_SUCCESS';
export const UPDATE_CONTEST_FAILURE = 'CMSEditContest/UPDATE_CONTEST_FAILURE';
export const RESET_UPDATED_IDS = 'CMSEditContest/RESET_UPDATED_IDS';
